import { useCallback, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import CollectionsGrid from '../../Components/CollectionsGrid';
import CreateCollectionForm from '../../Components/CreateCollectionForm';
import Modal from '../../Components/Modal';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { Collection } from '../../lib/types';
import {
  appSelectors,
  clearCreateCollectionLoading,
  removeCollection,
} from '../../redux/appSlice';

export const UserCollection = () => {
  const dispatch = useAppDispatch();
  const userCollectionsLoading = useAppSelector(
    appSelectors.userCollectionsLoading
  );
  const userCollections = useAppSelector(appSelectors.userCollections);
  const loggedIn: boolean = useAppSelector(appSelectors.isLoggedIn);
  const [addCollectionModalOpen, setAddCollectionModalOpen] =
    useState<boolean>(false);
  const [deleteCollectionModalOpen, setDeleteCollectionModalOpen] =
    useState<boolean>(false);
  const [collectionSelectedForDelete, setCollectionSelectedForDelete] =
    useState<Collection | undefined>(undefined);

  const handleOpenButtonClick = useCallback(() => {
    dispatch(clearCreateCollectionLoading());
    setAddCollectionModalOpen(true);
  }, [dispatch]);

  const handleAddCollectionModalClose = () => {
    setAddCollectionModalOpen(false);
  };

  const handleRemoveCollectionClick = (collection: Collection) => {
    setCollectionSelectedForDelete(collection);
    setDeleteCollectionModalOpen(true);
  };

  const handleRemoveCollectionConfirm = useCallback(
    (collection: Collection) => {
      dispatch(removeCollection(collection.ref));
    },
    [dispatch]
  );

  const handleDeleteCollectionModalClose = useCallback(
    (confirm: boolean = false) => {
      if (confirm && collectionSelectedForDelete) {
        handleRemoveCollectionConfirm(collectionSelectedForDelete);
        setCollectionSelectedForDelete(undefined);
      }
      setDeleteCollectionModalOpen(false);
    },
    [collectionSelectedForDelete, handleRemoveCollectionConfirm]
  );

  return (
    <div className="user-collections-wrapper">
      <div className="user-collections-header">
        <h2>Your collections</h2>
        {loggedIn && (
          <button onClick={handleOpenButtonClick}>Add a new collection</button>
        )}
      </div>
      {loggedIn && (
        <>
          <Modal
            showBack={true}
            onClose={handleAddCollectionModalClose}
            isOpened={addCollectionModalOpen}
            title="Add a new collection"
          >
            <CreateCollectionForm close={handleAddCollectionModalClose} />
          </Modal>
          {collectionSelectedForDelete && (
            <Modal
              showBack={false}
              isOpened={deleteCollectionModalOpen}
              title={`Are you sure you want to delete ${
                collectionSelectedForDelete?.name || 'this collection'
              }?`}
              onClose={() => handleDeleteCollectionModalClose(false)}
            >
              <div className="collection-delete-content">
                <ul>
                  <li>
                    <button
                      onClick={() => handleDeleteCollectionModalClose(true)}
                      className="button-confirm"
                    >
                      Yes
                    </button>
                  </li>
                  <li>
                    <button
                      className="button-cancel"
                      onClick={() => handleDeleteCollectionModalClose()}
                    >
                      No
                    </button>
                  </li>
                </ul>
              </div>
            </Modal>
          )}
          <CollectionsGrid
            collections={userCollections}
            onRemoveCollection={handleRemoveCollectionClick}
          />
        </>
      )}
      {!loggedIn && <p>You're not logged in</p>}
      {userCollectionsLoading && <BeatLoader color="#000000" />}
    </div>
  );
};
